// 弹窗通知时间storage key
export const NOTICE_POP_SHOW_DATE = 'huibo_digital_anchor_notice_pop_show_date';